import FolderIcon from '@mui/icons-material/FolderOutlined';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import Spin from 'components/Spin';
import React, { useState, useEffect } from 'react';
import * as fileService from 'services/files.service';

const FolderSelectModal = ({ onSelect, file, account, exclude, onClose }) => {
  const [folders, setFolders] = useState();
  const [selected, setSelected] = useState();

  useEffect(() => {
    fileService.listFolders({ account_id: account.account_id }).then((resp) => {
      const items = resp.filter((f) => f.folder_id !== exclude);
      setFolders(items);
    });
  }, []);

  return (
    <Modal
      open
      maxWidth="xs"
      title="Select destination folder"
      onClose={onClose}
      actions={
        <Button
          disabled={!selected}
          variant="contained"
          onClick={() => onSelect(selected, file)}
        >
          Submit
        </Button>
      }
    >
      {!folders ? (
        <Spin spinning />
      ) : (
        <List>
          {folders.map((f) => (
            <ListItem
              button
              selected={f.folder_id === selected}
              key={f.folder_id}
              onClick={() => setSelected(f.folder_id)}
            >
              <ListItemIcon>
                <FolderIcon />
              </ListItemIcon>
              <ListItemText primary={f.folder_name} />
            </ListItem>
          ))}
        </List>
      )}
    </Modal>
  );
};

export default FolderSelectModal;
